<div class="content container-fluid">
  <div class="header ahoy-border-card flex-wrap gap-3">
    <div class="profile-img-container">
      <div class="profile-img-content">
        <img
          src="{{
            imgUrl ? imgUrl : 'assets/sgs-dashboard/customer-profile.png'
          }}"
          alt=""
          class="profile-img"
        />
        @if (uploadingImg) {
          <div class="img-upload-overlay">
            <mat-spinner diameter="30"></mat-spinner>
          </div>
        }
        <input
          #imgInput
          hidden="true"
          type="file"
          onclick="this.value = null"
          (change)="uploadProfileImg($event)"
          accept=".png,.jpeg,.jpg"
          appTrackInput="profilePicture"
        />
        <mat-icon class="action-icon" [matMenuTriggerFor]="profileImgMenu"
          >more_vert</mat-icon
        >
        <mat-menu #profileImgMenu="matMenu">
          <button
            mat-menu-item
            (click)="imgInput.click()"
            appTrackClick="replace-profile-picture-btn"
          >
            <mat-icon>upload</mat-icon>
            <span translate>Upload Photo</span>
          </button>
          @if (imgUrl) {
            <button
              mat-menu-item
              (click)="confirmRemoveImg()"
              appTrackClick="remove-profile-picture-btn"
            >
              <mat-icon>delete</mat-icon>
              <span translate>Delete Photo</span>
            </button>
          }
        </mat-menu>
      </div>
      <div>
        <div class="fw-500 fs-16">
          {{ profileDetails?.firstName }} {{ profileDetails?.lastName }}
        </div>
        <div class="fs-13 text-secondary">
          {{ genderHash[profileDetails?.gender] }} -
          {{ profileDetails?.nationality?.name }}
        </div>
      </div>
    </div>

    <div
      class="pending-deletion-info"
      *ngIf="deletionRequest?.status === 'Pending' && !isDeletionExpired"
    >
      <span *ngIf="!deletionRequest.canConfirmNow" class="cooloff-text">
        {{ 'account.delete.pendingBanner' | translate }}
        <strong class="countdown-text">{{ coolOffCountdown }}</strong>
      </span>
      <span class="pending-badge">
        <mat-icon class="badge-icon">warning_amber</mat-icon>
        <span translate>account.delete.pendingLabel</span>
      </span>
    </div>

    <button mat-flat-button color="warn" [matMenuTriggerFor]="accountMenu">
      <mat-icon>expand_more</mat-icon>
      <span translate>Delete Account</span>
    </button>

    <mat-menu #accountMenu="matMenu">
      <ng-container
        *ngIf="
          deletionRequest?.status !== 'Pending' || isDeletionExpired;
          else confirmDeleteMenuItem
        "
      >
        <button
          mat-menu-item
          (click)="removeAccount()"
          appTrackClick="delete-account-btn"
        >
          <mat-icon>delete</mat-icon>
          <span translate>Delete Account</span>
        </button>
      </ng-container>

      <ng-template #confirmDeleteMenuItem>
        <span
          [matTooltip]="
            !deletionRequest.canConfirmNow
              ? ('account.delete.availableAfter' | translate) +
                ' ' +
                (deletionRequest.coolOffUntilUtc | date: 'medium')
              : null
          "
        >
          <button
            mat-menu-item
            [disabled]="!deletionRequest.canConfirmNow"
            (click)="confirmDeletion()"
          >
            <mat-icon>delete</mat-icon>
            <span translate>account.delete.confirmCta</span>
          </button>
        </span>
      </ng-template>

      <button mat-menu-item (click)="openDeactivateConfirmation()">
        <mat-icon>pause_circle</mat-icon>
        <span translate>account.deactivate.title</span>
      </button>
    </mat-menu>
  </div>

  <form
    class="profile-info mt-3 ahoy-border-card"
    [formGroup]="profileFormGroup"
    appTrackForm
  >
    <div class="d-flex align-items-center justify-content-between mb-3">
      <section-heading class="m-0" translate
        >Profile Information</section-heading
      >
      @if (!editingProfile) {
        <button
          mat-flat-button
          color="primary"
          (click)="editingProfile = true"
          appTrackClick="edit-profile-details-btn"
        >
          <span translate>Edit</span>
        </button>
      }
      @if (editingProfile) {
        <div class="d-flex gap-2">
          <button
            mat-stroked-button
            color="primary"
            (click)="undoProfileChanges()"
            appTrackClick="cancel-profile-changes-btn"
          >
            <span translate>Dismiss</span>
          </button>
          <button
            [hidden]="savingProfileChanges"
            mat-flat-button
            color="primary"
            [disabled]="!isValid() || savingProfileChanges"
            (click)="saveProfileChanges()"
            appTrackClick="save-profile-changes-btn"
            ctaType="primary"
          >
            @if (savingProfileChanges) {
              <app-loader [isLoading]="true"></app-loader>
            }
            <span translate>Update</span>
          </button>
        </div>
      }
    </div>
    @if (!editingProfile) {
      <div class="info-container">
        <info-pair label="First Name">
          {{ profileDetails?.firstName }}
        </info-pair>
        <info-pair label="Last Name">
          {{ profileDetails?.lastName }}
        </info-pair>
        <info-pair label="Identification">
          {{ profileDetails?.identification?.type?.name }} -
          {{ profileDetails?.identification?.number }}
        </info-pair>
        <info-pair label="Date of Birth">
          {{ (profileDetails?.dateOfBirth | date: 'longDate') || 'N/A' }}
        </info-pair>
      </div>
    }
    @if (editingProfile) {
      <div class="col-md-8">
        <div class="row full-name">
          <div class="col-sm-6 info-col first-name">
            <mat-label for="firstName" translate
              >First Name <sup>*</sup></mat-label
            >
            <mat-form-field [hideRequiredMarker]="true" appearance="outline">
              <input
                #firstName
                id="firstName"
                type="text"
                matInput
                formControlName="firstName"
                [placeholder]="'First Name' | translate"
              />
              <mat-error>
                <span translate>Invalid Value</span>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-sm-6 info-col last-name">
            <mat-label for="lastName" translate
              >Last Name <sup>*</sup></mat-label
            >
            <mat-form-field [hideRequiredMarker]="true" appearance="outline">
              <input
                #lastName
                type="text"
                id="lastName"
                matInput
                formControlName="lastName"
                [placeholder]="'Last Name' | translate"
              />
              <mat-error>
                <span translate>Invalid Value</span>
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-sm-6 info-col brith-date">
            <mat-label translate>Date of Birth</mat-label>
            <mat-form-field appearance="outline">
              <input
                #birthDate
                id="birthDate"
                matInput
                [matDatepicker]="picker"
                [max]="maxDate"
                formControlName="birthDate"
                [placeholder]="'MM/DD/YYYY (e.g., 04/28/1990)' | translate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-sm-6 info-col gender">
            <mat-label for="gender" translate>Gender</mat-label>
            <mat-form-field appearance="outline">
              <mat-select #gender id="gender" formControlName="gender">
                @for (gender of genderTypes; track gender) {
                  <mat-option [value]="gender.id">
                    {{ gender.type }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="identifications">
          <div class="row id-body">
            <div class="col-sm-6 info-col nationality">
              <mat-label translate>Nationality</mat-label>
              <mat-form-field appearance="outline">
                <mat-select
                  #nationality
                  id="nationality"
                  formControlName="nationality"
                  [hideSingleSelectionIndicator]="true"
                  panelClass="w-100"
                >
                  @for (country of countries; track country) {
                    <mat-option
                      [value]="country.id"
                      class="country-option-container"
                    >
                      <div class="countries-options">
                        <p class="country-name">
                          {{ country.code | translate }}
                        </p>
                        <img
                          class="country-flag"
                          src="{{ country.flagUrl }}"
                          alt=""
                        />
                      </div>
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-sm-6 info-col id-type">
              <mat-label translate>Identification Type</mat-label>
              <mat-form-field appearance="outline">
                <mat-select
                  (valueChange)="idTypeChanged($event)"
                  #idType
                  id="idType"
                  formControlName="idType"
                >
                  @for (idType of idTypes$ | async; track idType) {
                    <mat-option [value]="idType.id">
                      {{ idType.name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-sm-6 info-col id-number">
              <mat-label for="idNumber" translate>{{
                selectedIdentificationType
              }}</mat-label>
              <mat-form-field [hideRequiredMarker]="true" appearance="outline">
                <input
                  #idNumber
                  id="idNumber"
                  type="text"
                  matInput
                  formControlName="idNumber"
                  [placeholder]="selectedIdentificationType"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    }
  </form>

  <div class="mt-3 ahoy-border-card mb-3">
    <div class="d-flex align-items-center justify-content-between mb-3">
      <section-heading class="m-0" translate
        >Account Information</section-heading
      >
    </div>

    <div class="security-row">
      <div class="security-info">
        <mat-icon class="security-icon">mail_outline</mat-icon>
        <info-pair label="Email Address">{{ profileDetails?.email }}</info-pair>
      </div>
      <button
        mat-stroked-button
        color="primary"
        (click)="openChangeEmailDialog()"
        appTrackClick="update-email-btn"
      >
        <span translate>Update</span>
      </button>
    </div>

    <div class="ahoy-divider security-divider"></div>

    <div class="security-row">
      <div class="security-info">
        <mat-icon class="security-icon">phone_iphone</mat-icon>
        <info-pair label="Phone Number">{{ profileDetails?.phone }}</info-pair>
      </div>
      <button
        mat-stroked-button
        color="primary"
        (click)="openChangePhoneDialog()"
        appTrackClick="update-phone-btn"
      >
        <span translate>Update</span>
      </button>
    </div>

    <div class="ahoy-divider security-divider"></div>

    <div class="security-row">
      <div class="security-info">
        <mat-icon class="security-icon">lock</mat-icon>
        <info-pair label="Password"> ******** </info-pair>
      </div>
      <button
        mat-stroked-button
        color="primary"
        (click)="openChangePasswordDialog()"
        appTrackClick="update-password-btn"
      >
        <span translate>Update</span>
      </button>
    </div>
  </div>
</div>
